import { PaginatedListOfExerciseTagDto } from "@growth-machine-llc/stridist-api-client";
import { useOptimisticUpdateMutation } from "../../../../hooks/useOptimisticUpdateMutation";
import { COACH_EXERCISE_TAGS_LIST_QUERY_KEY } from "../../../../routes/coach/library/exercise-library/list/CoachExerciseTagsListRoute";
import ExerciseTagsService from "../../../../services/ExerciseTagsService";
import { useQueryClient } from "@tanstack/react-query";
import { INVALIDATE_KEYS_ON_EXERCISE_TAGS_LIST_UPDATE } from "./useCreateExerciseTag";
import {
  ALL_OPTIONS,
  useExerciseListFilterContext,
} from "../../../../contexts/ExerciseLibraryFilterContext";
import { NONE_TAG_ID } from "../../filters/TagsFilters";
import { tagOnSuccessHandler } from "../../../coach-clients-tags/mutations/useCreateClientTag";
export function useDeleteExerciseTag() {
  const queryClient = useQueryClient();
  const { tagIds, handleTagIdsChange } = useExerciseListFilterContext() || {
    tagIds: [],
    handleTagIdsChange: () => {},
  };
  return useOptimisticUpdateMutation({
    queryKey: [COACH_EXERCISE_TAGS_LIST_QUERY_KEY],
    mutationFn: ExerciseTagsService.deleteExerciseTag,
    optimisticUpdater: {
      updateFn: (oldData: PaginatedListOfExerciseTagDto, id: number) => {
        return {
          ...oldData,
          totalCount: oldData.totalCount - 1,
          items: oldData.items.filter((item) => item.id !== id),
        } as PaginatedListOfExerciseTagDto;
      },
    },

    exactQueryKey: false,
    options: {
      onSuccess: (_, id) => {
        tagOnSuccessHandler(
          queryClient,
          INVALIDATE_KEYS_ON_EXERCISE_TAGS_LIST_UPDATE,
        );

        if (
          tagIds !== ALL_OPTIONS &&
          Array.isArray(tagIds) &&
          tagIds.length > 0 &&
          tagIds.includes(id)
        ) {
          const newTagIds = tagIds.filter((tagId) => tagId !== id);
          handleTagIdsChange(newTagIds.length > 0 ? newTagIds : [NONE_TAG_ID]);
        }
      },
    },
  });
}
